import React, { useState } from "react";
import { Form, Formik, Field } from "formik";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import ModalInput from "../../components/FormInput/ModalInput";
import { EmailSchema } from "../../utils/validation";
import UserSettingsActions from "./UserSettingsActions";
import { updateUser, resetUser } from "../../redux/Actions/SingleUserActions";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { logOut } from "../../redux/Actions/LoginActions";
import { PropTypes } from "prop-types";
import ModalInput2 from "../../components/FormInput/ModalInput2";
import VerifyStaff from "../../components/Dashboard/Verify";

const UserSettings = ({
  updateUser,
  resetUser,
  isUpdatingUser,
  updateUserSuccess,
  logOut,
  error,
}) => {
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  let userToken = Storage.get("user-access-token");
  const user = JSON.parse(userStatus);
  let userEmail = user && user.email;
  let userType = user && user.type;

  const [state, setState] = useState({
    hide: true,
    showModal: false,
    newEmail: "",
    currentUserEmail: userEmail,
  });

  useEffect(() => {
    if (error && error.data && error.data.suspension_note) {
      const payload = {
        access_token: userToken
      }
      logOut(payload);
    }
  },
  // eslint-disable-next-line
  [error, userToken, logOut]);

  const showPasswordModal = () => {
    setState({
      ...state,
      showModal: true,
    });
  };

  useEffect(
    () => {
      resetUser();
    },
    // eslint-disable-next-line
    [resetUser]
  );

  useEffect(
    () => {
      if (updateUserSuccess) {
        const values = state.newEmail;
        const payload = {
          access_token: userToken
        }
        logOut(payload);
        history.push("/verify-email", values);
      }
    },
    // eslint-disable-next-line
    [updateUserSuccess]
  );

  const hidePasswordModal = () => {
    document.getElementById("form").reset()
    setState({
      ...state,
      showModal: false,
    });
  };

  return (
    <div className="container">
      <UserNav />
      <Sidebar />
      <VerifyStaff />

      <main className="container-body">
        <div className="settings">
          <div className="profile-box">
            <h1>Your Profile</h1>
            <div>
              <Formik
                enableReinitialize
                initialValues={{
                  email: state.currentUserEmail,
                }}
                onSubmit={(values) => {
                  const changeEmailValues = {
                    email: values.email.trim(),
                  };
                  updateUser(changeEmailValues);
                  setState({
                    ...state,
                    newEmail: changeEmailValues,
                  });
                }}
                validationSchema={EmailSchema}
              >
                {({ handleSubmit, isValid, dirty }) => {
                  return (
                    <Form id="editform">
                      <div className="modal-form">
                        <div className="form-grid">
                          {userType === "company" ?
                            <Field
                              name="email"
                              label="Email Address"
                              placeholder="Enter email"
                              component={ModalInput}
                            /> : (
                              <Field
                                name="email"
                                label="Email Address"
                                placeholder="Enter email"
                                component={ModalInput2}
                              />
                            )}
                        </div>

                        <div className="form-grid">
                          <div className="modal-input-container">
                            <label className="modal-input-label">User Role</label>
                            <input
                              style={{ textTransform: "capitalize" }}
                              value={userType}
                              className="modal-input-input"
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="password-section">
                          <p>Password</p>
                          <div
                            className="password-box"
                            onClick={showPasswordModal}
                          >
                            Change Password
                          </div>
                        </div>

                        <br />
                        <br />
                        <br />
                        <br />
                        {userType === "company" && <div className="modal-input-button">
                          <button
                            type="submit"
                            className="modal-action-button"
                            disabled={isUpdatingUser}
                          >
                            SAVE CHANGES
                          </button>
                        </div>}
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>

        <UserSettingsActions
          showModal={state.showModal}
          hideModal={hidePasswordModal}
        />
      </main>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateUser: (email) => dispatch(updateUser(email)),
  resetUser: () => dispatch(resetUser()),
  logOut: (payload) => dispatch(logOut(payload)),
});

const mapStateToProps = (state) => ({
  isUpdatingUser: state.singleStaff.isUpdatingUser,
  updateUserSuccess: state.singleStaff.updateUserSuccess,
  error: state.docs.error,
});

UserSettings.propTypes = {
  updateUser: PropTypes.func,
  resetUser: PropTypes.func,
  isUpdatingUser: PropTypes.bool,
  updateUserSuccess: PropTypes.bool,
  logOut: PropTypes.func,
  error: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);
